<template>
    <div class="row text-editor-block">
        <Loading v-if="!loaded" />
        <textarea v-show="loaded" :id="id" v-model="modelDuplicate"></textarea>
    </div>
</template>
<script>
    import Loading from "./Loading";
    export default {
        components: { Loading },
        props: {
            pid: String,
            model: String,
        },
        data() {
            return {
                loaded: false,
                id: this.pid,
                field_key: this.pid,
                modelDuplicate: this.model
            }
        },
        created() {
            this.id = this.id ? this.sanitizeValue(this.pid) : this.generateRandomId();

            let wait = !window.jQuery || !$('#' + this.id).length;
            if (wait) {
                setTimeout(() => this.init(), 500);
            } else {
                this.init();
            }
        },
        methods: {
            generateRandomId() {
                return 'wys-' + Date.now() + '-' + parseInt((Math.random() * 100), 10);
            },
            update(){
                this.$emit('updateContent', this.modelDuplicate);
            },
            async init() {
                let textarea = $('#' + this.id);
                this.loaded = true;
                textarea.trumbowyg({
                    btns: [['bold', 'italic', 'underline'], ['formatting'], ["unorderedList","orderedList"], ['link', 'insertImage'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'], ['viewHTML', 'fullscreen']],
                    autogrow: true,
                });
                textarea.trumbowyg().on('tbwchange', () => {
                    this.updateModelAndUpdate(textarea.trumbowyg('html'))
                }).on('tbwpaste', () => {
                    this.updateModelAndUpdate(textarea.trumbowyg('html'))
                });
            },
            updateModelAndUpdate(textareaHTML) {
                this.modelDuplicate = textareaHTML;
                this.update();
            },
            sanitizeValue(value) {
                value = value.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                return value.replace(/\./g, '-');
            }
        }
    }
</script>

<style lang="scss">
    .trumbowyg-modal {
        z-index: 100;
    }
</style>
